module.exports = __webpack_public_path__ + "static/img/AllInOne4.c870ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AllInOne4.png
// module id = uqxb
// module chunks = 2